import { RadioGroup as ChakraRadioGroup } from '@chakra-ui/react';
import { ItemProps } from '@chakra-ui/react/dist/types/components/radio-card/namespace';
import * as React from 'react';

export interface RadioProps extends ItemProps {
  rootRef?: React.Ref<HTMLDivElement>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  value?: string | number;
  children?: React.ReactNode;
  disabled?: boolean; // ➕ thêm dòng này
}

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>(function Radio(props, ref) {
  const { children, inputProps, rootRef, disabled, ...rest } = props;
  return (
    // @ts-ignore
    <ChakraRadioGroup.Item ref={rootRef} {...rest}>
      <ChakraRadioGroup.ItemHiddenInput ref={ref} {...inputProps} disabled={disabled} />
      <ChakraRadioGroup.ItemIndicator className="custom-radio-indicator" />
      {children && (
        <ChakraRadioGroup.ItemText>
          <span style={{ marginLeft: '6px' }}>{children}</span>
        </ChakraRadioGroup.ItemText>
      )}
    </ChakraRadioGroup.Item>
  );
});

export const RadioGroup = ChakraRadioGroup.Root;
